import { __awaiter, __generator, __values } from "tslib";
import { createQueryJob } from './job/query-job';
var QueryExecutor = /** @class */ (function () {
    function QueryExecutor(request, transaction) {
        this.onRequestSuccess = function () { };
        this.onRequestFailed = function () { };
        this.request = request;
        this.transaction = transaction;
        this.jobs = new Map();
    }
    QueryExecutor.prototype.exec = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.task) {
                    return [2 /*return*/, this.task];
                }
                this.task = new Promise(function (resolve, reject) {
                    _this.onRequestSuccess = function (outputs) {
                        _this.reset();
                        resolve(outputs);
                    };
                    _this.onRequestFailed = function (error) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            // TODO: implements gracefulShutdown
                            // await this.gracefulShutdown(error);
                            this.reset();
                            reject(error);
                            return [2 /*return*/];
                        });
                    }); };
                    // traverse all the query nodes, exec it from bottom to up in parallel
                    _this.traverse(_this.request.root, function (node, parent) {
                        var job = createQueryJob(node, (parent && _this.jobs.get(parent)) || null, _this.transaction);
                        _this.jobs.set(node, job);
                        if (!node.children.length) {
                            _this.beginJob(job).catch(function (err) {
                                _this.onRequestFailed(err);
                            });
                        }
                    });
                });
                return [2 /*return*/, this.task];
            });
        });
    };
    QueryExecutor.prototype.beginJob = function (job) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var outputs, err_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        outputs = ((_a = job.parent) === null || _a === void 0 ? void 0 : _a.context.inputs) || [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, job.perform(outputs)];
                    case 2:
                        _b.sent();
                        this.finishJob(job, outputs).catch(function (err) {
                            _this.onRequestFailed(err);
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.onRequestFailed(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    QueryExecutor.prototype.finishJob = function (job, outputs) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                if (job.parent) {
                    context = job.parent.context;
                    context.done += 1;
                    if (context.done === context.total) {
                        this.beginJob(job.parent).catch(function (err) {
                            _this.onRequestFailed(err);
                        });
                    }
                }
                if (job.node === this.request.root) {
                    this.onRequestSuccess(outputs);
                }
                return [2 /*return*/];
            });
        });
    };
    // TODO: implements gracefulShutdown
    // private async gracefulShutdown(error: Error) {
    //   throw new UnimplementedError({ error: error.message });
    // }
    QueryExecutor.prototype.reset = function () {
        this.jobs = new Map();
        this.task = undefined;
        this.onRequestSuccess = function () { };
        this.onRequestFailed = function () { };
    };
    QueryExecutor.prototype.traverse = function (node, cb, parent) {
        var e_1, _a;
        cb(node, parent);
        try {
            for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                this.traverse(child, cb, node);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return QueryExecutor;
}());
export default QueryExecutor;
//# sourceMappingURL=query-executor.js.map